export default "__VITE_ASSET__Cu$FRW2T__"